import request from "@/utils/request";

export function getDict(data) {
  return request({
    url: "/sys/sysDict/getDict/" + data,
    method: "get",
  });
}
